import "./assets/scss/Saas.scss"
import { withLDProvider } from "launchdarkly-react-client-sdk"
import Routes from "./routes/Routes"
import { useLogRocket } from "./lib/logrocket"

function App() {
  useLogRocket()
  return <Routes />
}

export default withLDProvider({
  clientSideID: process.env.REACT_APP_LAUNCHDARKLY_ID || "",
  context: {
    kind: "user",
    key: window.location.host.split(".")[0],
    name: "Example user",
    email: "User@example.com",
  },
})(App)
